import { fn0nZ, fn2 } from '../../../core/formatter/formatNumber';
import * as Moment from 'moment';
import * as React from 'react';
import style from './hochrechnung.less';

let DISABLE_KOSTEN: boolean;

export function renderVerbrauchRechnungen(
    hochrechnung: any, jahr: number, preis: number, einheit: string, disableKosten: boolean, onPreisChange: (preis: number) => void
): JSX.Element {
    DISABLE_KOSTEN = disableKosten || false;
    const verbrauch = hochrechnung.verbrauch_rechnungen;
    // console.log(gtz_jahr);
    const rows: JSX.Element[] = [];
    rows.push(makeHead(einheit));
    verbrauch.forEach((item: any) => rows.push(makeRow(item)));
    rows.push(makeSums(hochrechnung));
    rows.push(makePrognose(hochrechnung));

    const div_res = <div className={style.res_titel}><br /><br />
        Prognose für Abrechnungszeitraum &nbsp;&nbsp;
        {Moment(hochrechnung.az_von * 1000).format('DD.MM.YYYY')} -
        {Moment(hochrechnung.az_bis * 1000).format('DD.MM.YYYY')}
        <br />
        <br />
        <span className={style.res_label}>Prognose Verbrauch</span>
        <span className={style.res_value}>{fn0nZ(hochrechnung.verbrauch_prognose)} {einheit}</span>
        <br />
        {!DISABLE_KOSTEN && <>
            <span className={style.res_label}>Preisannahme</span>
            <span className={style.res_value}>
                {/*<input
                    type='number'
                    value = {preis}
                    onChange = {(evt: any) => onPreisChange(+evt.target.value)}
                />*/}
                {fn2(preis)} <span>€/{einheit}</span>
            </span>
            <br />
            <span className={style.res_label}>Prognose Kosten</span>
            <span className={style.res_value}>{fn0nZ(Math.round(hochrechnung.verbrauch_prognose * preis))} €</span>
            <br />
        </>}
    </div>;

    return <div>{rows}{div_res}</div>;
}

function makeRow(item: any): JSX.Element {
    // console.log(item);
    return <div className={style.row}>
        <div className={style.w80_grey_e}>{Moment(item.datum_von * 1000).format('YYYY-MM-DD')}</div>
        <div className={style.w80_grey_e}>{Moment(item.datum_bis * 1000).format('YYYY-MM-DD')}</div>
        <div className={style.w30_grey_e}>{fn2(item.verbrauch)}</div>
        {!DISABLE_KOSTEN && <>
            <div className={style.w30_grey_e}>{fn2(item.kosten)}</div>
            <div className={style.w30_grey_e}>{fn2(item.preis)}</div>
        </>}
        <div className={style.w30_grey_e}>{item.days}</div>
        <div className={style.w80_grey_e}>{fn2(item.gtz_faktor)}</div>
    </div>;
}

function makeSums(hochrechnung: any): JSX.Element {
    return <div className={style.row}>
        <div className={style.w80_grey_d}>Summe</div>
        <div className={style.w80_grey_d}></div>
        <div className={style.w30_grey_d}>{fn2(hochrechnung.sumVerbrauch)}</div>
        {!DISABLE_KOSTEN && <>
            <div className={style.w30_grey_d}></div>
            <div className={style.w30_grey_d}></div>
        </>}
        <div className={style.w30_grey_d}>{hochrechnung.sumDays}</div>
        <div className={style.w80_grey_d}></div>
    </div>;
}

function makePrognose(hochrechnung: any): JSX.Element {
    return <div className={style.row}>
        <div className={style.w80_grey_d} style={{ fontWeight: 'bold' }}>Prognose</div>
        <div className={style.w80_grey_d}></div>
        <div className={style.w30_grey_d} style={{ fontWeight: 'bold' }}>{fn2(hochrechnung.verbrauch_prognose)}</div>
        {!DISABLE_KOSTEN && <>
            <div className={style.w30_grey_d}></div>
            <div className={style.w30_grey_d}></div>
        </>}
        <div className={style.w30_grey_d} style={{ fontWeight: 'bold' }}>{hochrechnung.az_days}</div>
        <div className={style.w80_grey_d} style={{ fontWeight: 'bold' }}></div>
    </div>;
}

function makeHead(einheit: string): JSX.Element {
    return <div className={style.row}>
        <div className={style.w80_grey_8}>Von</div>
        <div className={style.w80_grey_8}>Bis</div>
        <div className={style.w30_grey_8}>Verbrauch [{einheit}]</div>
        {!DISABLE_KOSTEN && <>
            <div className={style.w30_grey_8}>Kosten [€]</div>
            <div className={style.w30_grey_8}>Preis [€/{einheit}]</div>
        </>}
        <div className={style.w30_grey_8}>Tage</div>
        <div className={style.w80_grey_8}>Klimafaktor</div>
    </div>;
}

/*
    datum_von: lastStamp,
    datum_bis: item.datum_befuellung,
    verbrauch: item.fuellmenge,
    kosten: item.kosten,
    preis: item.kosten / item.fuellmenge
*/
